import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./workCards";
import Particle from "../Particle";

import intern from "../../Assets/Projects/intern.gif";


function work() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Experiences </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few companies I've interned at.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={intern}
              isBlog={false}
              title="VIGNAM LABS"
              description="Software Developer Intern: Contributed to the design and implementation front-end and back-end functionalities for a wide range of screen sizes using React.js,Javascript,NodeJS.Collaborated with senior developers to implement secure user authentication protocols, advanced data visualization dashboards,and seamlessly integrated APIs enhancing user experience and reducing login issues "
            //   ghLink="https://github.com/tanvi2807/img-search-engine"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={intern}
              isBlog={false}
              title="PETMOJO"
              description="Frontend Developer Intern: Developed and optimized the entire front-end functionality of the website, ensuring responsiveness across all devices using ReactJS, TailwindCSS, and JavaScript. Also Created 12-15 RESTful APIs in NodeJS and ExpressJS for fetching and sending data to a MongoDB database."
            //   ghLink="https://github.com/tanvi2807/UrlShortner"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default work;